// Real customer testimonials — the single source for the homepage section and
// the /reviews page. Only verifiable fields (name, location, quote, rating).
// For the full, third-party-verified reviews we link out to the platforms below.
export const testimonials = [
  {
    name: 'Jennifer and John',
    location: 'United States',
    flag: '🇺🇸',
    rating: 5,
    title: 'Trip of a lifetime!',
    quote:
      'We are very pleased in all aspects with our trip. Jambo Travel took care of everything and made it easy for us to show up and be taken care of. They left nothing out, and we were pampered from beginning to end. Joseph, our tour guide, was fabulous — he never tired of our endless questions and became like part of our family by the end of the trip. Our game drives brought us up close with the "Big 5" and the "Special 5", and we truly enjoyed all the arrangements made by Jambo Travel.',
  },
  {
    name: 'June Titus',
    location: 'South Africa',
    flag: '🇿🇦',
    rating: 5,
    title: 'Job well done!',
    quote:
      'It has been such a pleasure to work with Mark Song and the Jambo team. Mark showed professionalism at all times, even going above and beyond to make sure that our Annual Meeting was successful — running smoothly with the logistics of participants across two hotels. I would definitely recommend Jambo Travel House.',
  },
  {
    name: 'Eli',
    location: 'Norway',
    flag: '🇳🇴',
    rating: 5,
    title: 'Excellent, safe drivers',
    quote:
      'We have used Jambo Travel for many years and we feel safe travelling with them. The drivers are experienced and have good knowledge about the country and wildlife. They are service-minded. We travelled from Nairobi to Muhoroni-Kisumu and the Masai Mara. We really recommend Jambo Travel.',
  },
  {
    name: 'Robert Chris',
    location: 'French Guiana',
    flag: '🇬🇫',
    rating: 5,
    title: 'A great company!',
    quote:
      'Great experience with Jambo Travel House Holidays. We had 3 days across Ngorongoro, Serengeti and Lake Manyara. I would like to appreciate the organization and the guides — very well prepared.',
  },
  {
    name: 'Anne-Marie',
    location: 'Norway',
    flag: '🇳🇴',
    rating: 5,
    title: 'Excellent service throughout',
    quote:
      'We had an unforgettable tour with Jambo Travel House. Reliability is excellent and the service was very good.',
  },
];

// Third-party review platforms Jambo is listed/reviewed on.
export const REVIEW_LINKS = [
  { name: 'Tripadvisor', href: 'https://www.tripadvisor.com/Attraction_Review-g294207-d18843478-Reviews-Jambo_Travelhouse_Holidays-Nairobi.html' },
  { name: 'SafariBookings', href: 'https://www.safaribookings.com/p5824' },
  { name: 'SafariGo', href: 'https://www.safarigo.com/operator/jambo-travelhouse-holidays-limited--1761' },
];
